import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import IssuesModel from '../models/IssuesModel'
import MapLayerSwitcher from './MapLayerSwitcher'
import { Row, Col, Input, InputNumber, Radio, Select, Checkbox, Button, Icon, Alert, Modal  } from 'antd'
import legenda_ai from '../assets/images/legenda-ai.png'
import legenda_aii from '../assets/images/legenda-aii.png'
import legenda_bi from '../assets/images/legenda-bi.png'
import legenda_bii from '../assets/images/legenda-bii.png'
import legenda_c from '../assets/images/legenda-c.png'
import legenda_d from '../assets/images/legenda-d.png'
const { TextArea } = Input
const RadioGroup = Radio.Group
const Option = Select.Option

class IssueStep2 extends Component {

    constructor(props) {
        super(props)
        this.onChangeAddress = this.onChangeAddress.bind(this)
        this.putMapMarker = this.putMapMarker.bind(this)
        this.onGetDeviceGeolocation = this.onGetDeviceGeolocation.bind(this)
        this.renderMap = this.renderMap.bind(this)
        this.mapMarker = false
        this.mapSelectDrag = false

        this.state = {
            legenda_modal: false,
            legenda_img: legenda_ai
        }
    }

    componentDidMount() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const map = this.props.map
        IssuesModel.olMap = map
        map.setTarget(mapTarget)
        map.getView().setZoom(this.props.mapZoom)
        map.getView().setCenter(this.props.mapCenter)
    }

    componentWillReceiveProps(nextProps) {
        const map = this.props.map
        map.getView().setZoom(nextProps.mapZoom)
        map.getView().setCenter(nextProps.mapCenter)
        if (nextProps.id) this.putMapMarker(nextProps.mapCenter)
        if (nextProps.className === 'visible') {
            this.renderMap()
        }
    }

    showLegendModal = (legenda_img) => {
        this.setState({
            legenda_modal: true,
            legenda_img: legenda_img,
        });
    }

    hideLegendModal = (e) => {
        this.setState({
          legenda_modal: false
        });
      }

    // Put map marker
    putMapMarker(coords) {
        this.mapMarker = IssuesModel.putMarker(coords, true)

        // Add select and drag interaction
        if (!this.mapSelectDrag) {
            this.mapSelectDrag = IssuesModel.addMapSelectAndDrag((coords) => {
                this.props.changeMapCenter(coords.native, this.props.map.getView().getZoom(), true)
            })

            // Add marker to select control
            this.mapSelectDrag.getFeatures().push(this.mapMarker)
            this.props.changeMapCenter(coords, this.props.map.getView().getZoom(), true)
        }
    }

    renderMap() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const updateMap = setInterval(() => {
            if (mapTarget.offsetHeight) {
                this.props.map.updateSize()
                return clearInterval(updateMap)
            }
        }, 50)
    }

    onChangeAddress(address) {
        this.props.gmapsGeocoder(address)
    }

    onGetDeviceGeolocation() {
        this.props.getDeviceGeolocation()
    }

    componentWillUnmount() {
        this.props.map.setTarget(null)
    }

    noAccents(s) {
        var r = s.toLowerCase();
        r = r.replace(new RegExp("\\s", 'g'),"");
        r = r.replace(new RegExp("[àáâãäå]", 'g'),"a")
        r = r.replace(new RegExp("æ", 'g'),"ae")
        r = r.replace(new RegExp("ç", 'g'),"c")
        r = r.replace(new RegExp("[èéêë]", 'g'),"e")
        r = r.replace(new RegExp("[ìíîï]", 'g'),"i")
        r = r.replace(new RegExp("ñ", 'g'),"n")
        r = r.replace(new RegExp("[òóôõö]", 'g'),"o")
        r = r.replace(new RegExp("œ", 'g'),"oe")
        r = r.replace(new RegExp("[ùúûü]", 'g'),"u")
        r = r.replace(new RegExp("[ýÿ]", 'g'),"y")
        r = r.replace(new RegExp("\\W", 'g'),"")
        return r
    }

    render() {
        return (
            <div className={this.props.className}>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Localização</legend></Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="address" className="ant-form-item-required" title="Localizar por endereço">Localização</label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <Input ref="address"
                            value={this.props.address}
                            onChange={(e) => this.props.onChangeField('address', e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' ? this.onChangeAddress(this.props.address) : false }
                            suffix={(<Button type="primary" onClick={(e) => this.onChangeAddress(this.props.address) }>
                                <span className="hide-small">Centrar no Mapa</span>
                                <span className="hide-medium">
                                    <Icon type="environment" />
                                </span>
                            </Button>)}
                        />
                        <div className="map" id="map" ref="map" style={{height: '252px', marginTop: '24px'}}>
                            <div id="putMapMarker">
                                <Button type="primary" icon="pushpin"
                                    title="Definir localização geográfica"
                                    onClick={(e) => this.putMapMarker(this.props.mapCenter)}
                                />
                            </div>
                            <div id="deviceGeo">
                                <Button type="primary" icon="global"
                                    title="Obter coordenadas do dispositivo"
                                    onClick={(e) => this.onGetDeviceGeolocation()}
                                />
                            </div>
                            <MapLayerSwitcher map={this.props.map} />
                        </div>
                        { this.props.v.show && this.props.v.freguesia.msg && !this.props.freguesia ? (
                            <Alert message={this.props.v.freguesia.msg} type="error" showIcon />
                        ) : '' }
                    </div>
                </div>

                <div className="ant-row ant-form-item" style={{marginBottom: '0', display: this.props.freguesia ? 'none' : 'block' }}>
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6"></div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <label className="ant-form-item-required location-warning blink-me" title="Localização obrigatória">
                            Coloque o marcador no mapa clicando <a role="button" title="Definir localização geográfica"
                                onClick={(e) => this.putMapMarker(this.props.mapCenter)}
                            >aqui</a> e arraste para a zona litoral
                        </label>
                    </div>
                </div>
                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="freguesia" className="ant-form-item-required" title="Freguesia, Concelho e Distrito">
                            Freguesia | Concelho | ARH
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-6">
                        <input ref="freguesia" value={this.props.freguesia || ''}
                            placeholder="Freguesia" readOnly={true}
                            className="ant-input"
                        />
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                        <input ref="concelho" value={this.props.concelho || ''}
                            placeholder="Concelho" readOnly={true}
                            className="ant-input"
                        />
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                        <input ref="distrito" value={this.props.arh || ''}
                            placeholder="ARH" readOnly={true}
                            className="ant-input"
                        />
                    </div>
                </div>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="roles_id" className="ant-form-item" title="Perfil de Utilizador">
                            Praia (se aplicável)
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <Select value={this.props.praia}
                            showSearch
                            allowClear
                            placeholder="Escolha a praia"
                            optionFilterProp="children"
                            onChange={(v) => this.props.onChangeField('praia', v)}
                            filterOption={(input, option) => this.noAccents(option.props.children).indexOf(this.noAccents(input)) >= 0}
                            >
                            { this.props.praias.map((item) => (
                                <Option key={''+item.id} value={''+item.title}>{item.title}</Option>
                            ) )}
                        </Select>
                    </div>
                </div>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}>
                        <legend>Tipologia</legend>
                        { this.props.v.show && this.props.v.tipo.msg && !this.props.type_a && !this.props.type_b && !this.props.type_c && !this.props.type_d ? (
                            <Alert message={this.props.v.tipo.msg} type="error" showIcon />
                        ) : '' }
                    </Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                        <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                            Tipologia da Ocorrência
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                        <ol>
                            <li>
                                <strong>a.{'  '}
                                    <Checkbox checked={this.props.type_a}
                                        onChange={(e) => this.props.onChangeField('type_a', e.target.checked)}>
                                        Instabilidade em arribas
                                    </Checkbox>
                                </strong>
                                <div style={{display: this.props.type_a ? 'block' : 'none'}}>
                                    <ol>
                                        <li>
                                            <Checkbox checked={this.props.type_ai}
                                                onChange={(e) => this.props.onChangeField('type_ai', e.target.checked)}>
                                                i. Movimento de massa de vertente (MMV)
                                                {' '}
                                                <Button type="primary" shape="circle"
                                                    title="Abrir legenda"
                                                    onClick={(e) => this.showLegendModal(legenda_ai)}
                                                >i</Button>
                                            </Checkbox>
                                            <div>
                                                <ol>
                                                    <li>
                                                        <span>Alcance máximo do depósito/detritos (m) </span>
                                                        <InputNumber min={0} max={9999}
                                                            value={this.props.type_ai_meters}
                                                            size="small"
                                                            style={{marginBottom: '-6px'}}
                                                            onChange={(v) => this.props.onChangeField('type_ai_meters', v)} />
                                                    </li>
                                                </ol>
                                            </div>
                                        </li>
                                        <li>
                                            <Checkbox checked={this.props.type_aii}
                                                onChange={(e) => this.props.onChangeField('type_aii', e.target.checked)}>
                                                ii. Fenda de tração com abertura visível
                                                {' '}
                                                <Button type="primary" shape="circle"
                                                    title="Abrir legenda"
                                                    onClick={(e) => this.showLegendModal(legenda_aii)}
                                                >i</Button>
                                            </Checkbox>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <strong>b.{'  '}
                                    <Checkbox checked={this.props.type_b}
                                        onChange={(e) => this.props.onChangeField('type_b', e.target.checked)}>
                                        Erosão/recuo da linha de costa
                                    </Checkbox>
                                </strong>
                                <div style={{display: this.props.type_b ? 'block' : 'none'}}>
                                    <ol>
                                        <li>
                                            <Checkbox checked={this.props.type_bi}
                                                onChange={(e) => this.props.onChangeField('type_bi', e.target.checked)}>
                                                i. Escarpamento da duna
                                                {' '}
                                                <Button type="primary" shape="circle"
                                                    title="Abrir legenda"
                                                    onClick={(e) => this.showLegendModal(legenda_bi)}
                                                >i</Button>
                                            </Checkbox>
                                            <div style={{display: this.props.type_bi ? 'block' : 'none'}}>
                                                <ol>
                                                    <li>
                                                        <span>Altura máxima da escarpa (m) </span>
                                                        <InputNumber min={0} max={99}
                                                            value={this.props.type_bi_meters}
                                                            size="small"
                                                            style={{marginBottom: '-6px'}}
                                                            onChange={(v) => this.props.onChangeField('type_bi_meters', v)}
                                                        />
                                                    </li>
                                                </ol>
                                            </div>
                                        </li>
                                        <li>
                                            <Checkbox checked={this.props.type_bii}
                                                onChange={(e) => this.props.onChangeField('type_bii', e.target.checked)}>
                                                ii. Rebaixamento da praia
                                                {' '}
                                                <Button type="primary" shape="circle"
                                                    title="Abrir legenda"
                                                    onClick={(e) => this.showLegendModal(legenda_bii)}
                                                >i</Button>
                                            </Checkbox>
                                            <div style={{display: this.props.type_bii ? 'block' : 'none'}}>
                                                <ol>
                                                    <li>
                                                        <span>Altura máxima (m) </span>
                                                        <InputNumber min={0} max={99}
                                                            value={this.props.type_bii_meters}
                                                            size="small"
                                                            style={{marginBottom: '-6px'}}
                                                            onChange={(v) => this.props.onChangeField('type_bii_meters', v)}
                                                        />
                                                    </li>
                                                </ol>
                                            </div>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <strong>c.{'  '}
                                    <Checkbox checked={this.props.type_c}
                                        onChange={(e) => this.props.onChangeField('type_c', e.target.checked)}>
                                        Dano em obra/estrutura de proteção costeira
                                        {' '}
                                        <Button type="primary" shape="circle"
                                            title="Abrir legenda"
                                            onClick={(e) => this.showLegendModal(legenda_c)}
                                        >i</Button>
                                    </Checkbox>
                                </strong>
                            </li>
                            <li><strong>d.{'  '}
                                    <Checkbox checked={this.props.type_d}
                                        onChange={(e) => this.props.onChangeField('type_d', e.target.checked)}>
                                        Galgamento costeiro
                                        {' '}
                                        <Button type="primary" shape="circle"
                                            title="Abrir legenda"
                                            onClick={(e) => this.showLegendModal(legenda_d)}
                                        >i</Button>
                                    </Checkbox>
                                </strong>
                                <div style={{display: this.props.type_d ? 'block' : 'none'}}>
                                    <ol>
                                        <li>
                                            <span>Alcance máximo da água/detritos (m) </span>
                                            <InputNumber min={0} max={99}
                                                value={this.props.type_d_meters}
                                                size="small"
                                                style={{marginBottom: '-6px'}}
                                                onChange={(v) => this.props.onChangeField('type_d_meters', v)}
                                            />
                                        </li>
                                    </ol>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Consequência(s) da Ocorrência</legend></Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                        <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                            Consequência(s) da Ocorrência
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                        <ol>
                            <li><strong>a. Pessoas em risco</strong>
                                <div>
                                    <RadioGroup value={this.props.cons_a}
                                        onChange={(e) => {this.props.onChangeField('cons_a', e.target.value)}}>
                                        <Radio value={'1'}>i. Não</Radio>
                                        <Radio value={'2'}>ii. Não sabe / Não aplicável</Radio>
                                        <Radio value={'3'}>iii. Sim</Radio>
                                    </RadioGroup>

                                    <div style={{display: this.props.cons_a === '3' ? 'block' : 'none'}}>
                                        <ol>
                                            <li>
                                                <Checkbox checked={this.props.cons_a === '3' && this.props.cons_aiii_qtt === 1}
                                                    onChange={(e) => this.props.onChangeField('cons_aiii_qtt', e.target.checked ? 1 : null)}>
                                                    1 - 10
                                                </Checkbox>
                                                <Checkbox checked={this.props.cons_a === '3' && this.props.cons_aiii_qtt === 2}
                                                    onChange={(e) => this.props.onChangeField('cons_aiii_qtt', e.target.checked ? 2 : null)}>
                                                    10 - 100
                                                </Checkbox>
                                                <Checkbox checked={this.props.cons_a === '3' && this.props.cons_aiii_qtt === 3}
                                                    onChange={(e) => this.props.onChangeField('cons_aiii_qtt', e.target.checked ? 3 : null)}>
                                                    > 100
                                                </Checkbox>
                                            </li>
                                        </ol>
                                    </div>

                                </div>
                            </li>
                            <li><strong>b. Danos em infra-estruturas</strong>
                                <div>
                                    <ol>
                                        <li>
                                            <Checkbox checked={this.props.cons_bi}
                                                onChange={(e) => this.props.onChangeCons(e.target.checked)}
                                                >
                                                i. Não
                                            </Checkbox>
                                        </li>
                                        <li>
                                            <Checkbox checked={this.props.cons_bii}
                                                onChange={(e) => this.props.onChangeConsItem('cons_bii', e.target.checked)}>
                                                ii. Estruturas de proteção/defesa costeira
                                            </Checkbox>
                                            <div style={{display: this.props.cons_bii ? 'block' : 'none'}}>
                                                <ol>
                                                    <li>
                                                        <Checkbox checked={this.props.cons_bii1}
                                                            onChange={(e) => this.props.onChangeConsItem('cons_bii1', e.target.checked)}>
                                                            1. Estrutura aderente
                                                        </Checkbox>
                                                    </li>
                                                    <li>
                                                        <Checkbox checked={this.props.cons_bii2}
                                                            onChange={(e) => this.props.onChangeConsItem('cons_bii2', e.target.checked)}>
                                                            2. Esporão/quebra-mar
                                                        </Checkbox>
                                                    </li>
                                                    <li>
                                                        <Checkbox checked={this.props.cons_bii3}
                                                            onChange={(e) => this.props.onChangeConsItem('cons_bii3', e.target.checked)}>
                                                            3. Obra de proteção/estabilização de Arriba
                                                        </Checkbox>
                                                    </li>
                                                </ol>
                                            </div>
                                        </li>
                                        <li>
                                            <Checkbox checked={this.props.cons_biii}
                                                onChange={(e) => this.props.onChangeConsItem('cons_biii', e.target.checked)}>
                                                iii. Áreas construídas de fruição/uso público
                                            </Checkbox>
                                            <ol>
                                                <li>
                                                    (e.g. passeio pedonal/passadiços/miradouro/zonas estadia)
                                                </li>
                                            </ol>
                                        </li>
                                        <li>
                                            <Checkbox checked={this.props.cons_biv}
                                                onChange={(e) => this.props.onChangeConsItem('cons_biv', e.target.checked)}>
                                                iv. Edificações
                                            </Checkbox>
                                            <ol>
                                                <li>
                                                    (e.g. habitações/comerciais/apoios de praia)
                                                </li>
                                            </ol>
                                        </li>
                                        <li>
                                            <Checkbox checked={this.props.cons_bv}
                                                onChange={(e) => this.props.onChangeConsItem('cons_bv', e.target.checked)}>
                                                v. Outras
                                            </Checkbox>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Medidas de mitigação ou minimização do risco</legend></Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                        <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                            Medidas de mitigação ou minimização do risco
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                        <RadioGroup value={this.props.miti}
                            onChange={(e) => {this.props.onChangeMiti(e.target.value)}}>
                            <Radio value={'1'}>i. Não</Radio>
                            <Radio value={'2'}>ii. Não sabe / Não aplicável</Radio>
                            <Radio value={'3'}>iii. Sim</Radio>
                        </RadioGroup>

                        <div>
                            <table className="miti-items">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th style={{width: '24px'}}><div className="vertical-text">Imediatas</div></th>
                                        <th style={{width: '24px'}}><div className="vertical-text">A adotar</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            i. Sinalização (aviso/interdição)
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_i === 'i'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_i', e.target.checked ? 'i' : null)}></Checkbox>
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_i === 'a'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_i', e.target.checked ? 'a' : null)}></Checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ii. Delimitação/interdição de área de risco
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_ii === 'i'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_ii', e.target.checked ? 'i' : null)}></Checkbox>
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_ii === 'a'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_ii', e.target.checked ? 'a' : null)}></Checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            iii. Saneamento de blocos/reperfilamento
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_iii === 'i'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_iii', e.target.checked ? 'i' : null)}></Checkbox>
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_iii === 'a'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_iii', e.target.checked ? 'a' : null)}></Checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            iv. Reabilitação de obra de proteção/estabilização
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_iv === 'i'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_iv', e.target.checked ? 'i' : null)}></Checkbox>
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_iv === 'a'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_iv', e.target.checked ? 'a' : null)}></Checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            v. Reforço/Alimentação artificial de emergência
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_v === 'i'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_v', e.target.checked ? 'i' : null)}></Checkbox>
                                        </td>
                                        <td>
                                            <Checkbox checked={this.props.miti_c_v === 'a'}
                                                onChange={(e) => this.props.onChangeMitiItem('miti_c_v', e.target.checked ? 'a' : null)}></Checkbox>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="description" className="ant-form-item-required" title="Observações da Ocorrência">Observações</label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <div className="ant-form-item-control ">
                            <TextArea id="description" rows={6} value={this.props.obs}
                                onChange={(e) => this.props.onChangeField('obs', e.target.value)} />
                        </div>
                    </div>
                </div>

                <Modal
                    visible={this.state.legenda_modal}
                    title="Legenda"
                    wrapClassName="vertical-center-modal"
                    onCancel={this.hideLegendModal}
                    footer={[]}
                    >
                        <div style={{textAlign: 'center'}}>
                            <img src={this.state.legenda_img} alt="" title="" style={{width: '100%'}} />
                        </div>
                    </Modal>

            </div>
        )
    }
}

export default IssueStep2;



// WEBPACK FOOTER //
// ./src/components/IssueStep2.js